/* @flow */
import * as React from 'react';
import Row from 'components/Row.jsx';
import EventTracking from 'lib/EventTracking';
import { withRouter } from 'app/context/Router.jsx';
import AdminUpgradeInfo from 'admin/components/AdminUpgradeInfo.jsx';
import AdminUpgradeTitle from 'admin/components/AdminUpgradeTitle.jsx';
import AdminUpgradeHelpForm from 'admin/components/AdminUpgradeHelpForm.jsx';
import AdminUpgradePageHeader from 'admin/components/AdminUpgradePageHeader.jsx';

import './styles/AdminUpgradePageView.scss';

type Props = {
  router: *,
};

class AdminUpgradeHelpPage extends React.Component<Props> {
  static trackingPrefix = 'admin_self_serve.help_page';

  componentDidMount() {
    this.track('view');
  }

  track = (key: string) => {
    EventTracking.trackKey(`${AdminUpgradeHelpPage.trackingPrefix}.${key}`);
  };

  handleDone = () => {
    this.props.router.push('/admin_upgrade/contact_us/done');
  };

  render() {
    return (
      <div className="AdminUpgradePageView">
        <AdminUpgradePageHeader title="Remind School and District Plans" hideHelp />
        <div className="AdminUpgradePageView-content">
          <div className="AdminUpgradePageView-content-body">
            <div className="AdminUpgradePageView-content-body-forms">
              <Row>
                <AdminUpgradeTitle
                  title="Questions about purchasing a Remind Plan?"
                  subtext="Our team is always happy to chat!"
                />
              </Row>
              <AdminUpgradeHelpForm onDone={this.handleDone} />
            </div>
            <div className="AdminUpgradePageView-content-body--desktop-side">
              <Row size="large">
                <AdminUpgradeInfo />
              </Row>
            </div>
          </div>
        </div>
        <div className="AdminUpgradePageView--mobile-bottom">
          <div className="AdminUpgradePageView-info-container">
            <AdminUpgradeInfo />
          </div>
        </div>
      </div>
    );
  }
}

export { AdminUpgradeHelpPage };
export default withRouter(AdminUpgradeHelpPage);
